<template>
  <div><slot></slot></div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { BoxBufferGeometry, MeshBasicMaterial, Mesh } from 'three'

export default {
  mixins: [O3DG2],
  methods: {
    setup () {
      let geo = new BoxBufferGeometry(30, 30, 30, 30, 30, 30)
      let mat = new MeshBasicMaterial({ wireframe: true, color: 0xff00ff })
      let mesh = new Mesh(geo, mat)
      this.onLoop(() => {
        mesh.rotation.x += 0.01
      })

      this.o3d.add(mesh)
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>
